module.exports = __webpack_public_path__ + "static/media/keltech.a1c82c1c.jpg";